export enum Views {
  ImageOrVideoCreativeTemplateEditor = 'imageOrVideoCreativeTemplateEditor',
  CarouselCreativeTemplateEditor = 'carouselCreativeTemplateEditor',
  CreativesGenerator = 'creativesGenerator'
}
